export default String.raw`
{% assign name = settings[bannerName] -%}
{% assign banner = config.Banners[name] -%}

{% if banner -%}
    {% assign images = banner.Images -%}
    {% assign imagesCount = banner.Images | Size -%}

    <div class="promoBanner2" id="{{name}}">
        {% if imagesCount > 0 -%}
            <div class="promoBanner2__wrapper swiper">
                <div class="swiper-wrapper">
                    {% for image in images -%}
                        {% assign settingsJSON = image.Settings | H -%}
                        {% capture content -%}

                            <picture class="promoBanner2__image lazy" title="{{ image.Title }}">
                                <source media="(max-width: 767px)" srcset="{{ image.UrlSmall }}" type="image/webp">
                                <source media="(max-width: 767px)" srcset="{{ image.UrlSmall }}">
                                <source media="(max-width: 1439px)" srcset="{{ image.UrlMedium }}" type="image/webp">
                                <source media="(max-width: 1439px)" srcset="{{ image.UrlMedium }}">
                                <source srcset="{{ image.Url }}" type="image/webp">

                                <img src="{{ image.Url }}" 
                                    alt="{{ image.Alt }}"
                                    width="1920" 
                                    height="860"
                                    decoding="{% if forloop.index0 == 0 -%}sync{% else -%}async{% endif -%}"
                                    {% unless settings.bodyMainBannerNo_1 == 1 -%}loading="{% if forloop.index0 == 0 -%}eager{% else -%}lazy{% endif -%}"{% else -%}fetchpriority="high"{% endunless -%}
                                >
                            </picture>

                            {% if image.Text != '' -%}
                                <p class="promoBanner2__text promoBanner2__text--position">{{ image.Text | Truncate: 200, "…" }}</p>
                            {% endif -%}

                            {% if settingsJSON contains 'timerDateTo' -%}
                                <div class="timer timer--position" style="visibility: hidden; opacity: 0; {% if settingsJSON contains '&quot;timerDateTo&quot;:&quot;&quot;' -%} display: none; {% endif -%}">
                                    <p class="timer__heading">{{translations.TimerOfferEndsAt}}</p>
                                    <div class="countdown">
                                        <div class="countdown__time-unit countdown__time-unit--days">0</div>
                                        <div class="countdown__separator">:</div>
                                        <div class="countdown__time-unit countdown__time-unit--hours">0</div>
                                        <div class="countdown__separator">:</div>
                                        <div class="countdown__time-unit countdown__time-unit--minutes">0</div>
                                        <div class="countdown__separator">:</div>
                                        <div class="countdown__time-unit countdown__time-unit--seconds">0</div>
                                        <div class="countdown__label countdown__label--days">{{translations.TimerLabelDays}}</div>
                                        <div class="countdown__label countdown__label--hours">{{translations.TimerLabelHours}}</div>
                                        <div class="countdown__label countdown__label--minutes">{{translations.TimerLabelMinutes}}</div>
                                        <div class="countdown__label countdown__label--seconds">{{translations.TimerLabelSeconds}}</div>
                                    </div>
                                </div>
                            {% endif -%}
                        {% endcapture -%}

                        {% if image.Link != '' -%}
                            {% assign link = '' -%}
                            {% capture link -%}{% include 'partials/common/user-link.html', userLink: image.Link -%}{% endcapture -%}

                            <a class="promoBanner2__item swiper-slide" href="{{link}}" target="{% if image.TargetBlank %}_blank{% else %}_self{% endif %}" data-settings='{{settingsJSON}}'>
                                {{ content }}
                            </a>
                        {% else -%}
                            <div class="promoBanner2__item swiper-slide" data-settings='{{settingsJSON}}'>
                                {{ content }}
                            </div>
                        {% endif -%}
                    {% endfor -%}
                </div>
                {% if imagesCount > 1 -%}
                    <button aria-label="{{translations.PrevSlide}}" class="swiper-button-next bar">
                        <svg class="arrow__icon">
                            <use href='css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-right-{{ settings.iconStyle }}'></use>
                        </svg>
                    </button>
                    <button aria-label="{{translations.NextSlide}}" class="swiper-button-next bar">
                        <svg class="arrow__icon">
                            <use href='css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-right-{{ settings.iconStyle }}'></use>
                        </svg>
                    </button>
                {% endif -%}
            </div>
        {% else-%}
            <div class="promoBanner2__placeholder">
                <img width="1920" height="680" class="promoBanner2__image--placeholder" src="css/img/img-placeholder.jpg" alt="{{translations.DefaultImage}}" width="1920" height="680">
                <h1 class="promoBanner2__label">{{name}}<br>1920x680<br></h1>
            </div>
        {% endif -%}
    </div>
{% endif -%}
`